import React from "react";
import "../styles/peopleCardSmall.css";

const PeopleCardSmall = ({ display_name, image }) => {
    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const imageUrl = image ? `https://raw.githubusercontent.com/imagine-uniandes/web_data/main/img/people/${image}` : '';
    const initials = getInitials(display_name);

    return (
        <div className="people-card-small">
            <div className={`pcs-avatar ${!imageUrl ? 'has-initials' : ''}`} 
                 data-initials={!imageUrl ? initials : ''}>
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt={display_name}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentNode.classList.add('has-initials');
                            e.target.parentNode.setAttribute('data-initials', initials);
                        }}
                    />
                )}
            </div>
            <div className="pcs-info">
                <p className="pcs-name">{display_name}</p>
            </div>
        </div>
    );
};

export default PeopleCardSmall;